import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import DialogContainer from '@shared/ui/dialog/DialogContainer';
import { useSignUpStore } from '../../../application/store/SignUpStore';

/**
 * Public landing for shared referral links (`/referral/:code`).
 * Persists the code into onboarding state, then continues into sign-up.
 */
const ReferralLanding: React.FC = () => {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    const referralCode = code?.trim();
    if (!referralCode) {
      navigate('/sign-up/email', { replace: true });
      return;
    }

    useSignUpStore.getState().setReferralCode(referralCode);
    navigate('/sign-up/email', { replace: true });
  }, [code, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        bgcolor: 'background.default',
        p: 0,
      }}
    >
      <DialogContainer maxWidth="600px">
        <Box sx={{ position: 'relative', m: 4 }}>
          <Box sx={{ textAlign: 'left', mb: 3 }}>
            <img
              src="/assets/images/ic_just_stock.png"
              alt="JustStock Logo"
              style={{ height: 16 }}
            />
          </Box>

          <Stack alignItems="center" spacing={2} sx={{ py: 4 }}>
            <CircularProgress size={28} />
            <Typography variant="body1" fontWeight={600}>
              Applying your referral…
            </Typography>
            <Typography variant="body2" color="text.secondary" textAlign="center">
              You&apos;ll continue to create your JustStock account.
            </Typography>
          </Stack>
        </Box>
      </DialogContainer>
    </Box>
  );
};

export default ReferralLanding;
